var mixins = {
  filters: {
    formatMoney (val) {
      var f = parseFloat(val);
      if (isNaN(f)) {
        return '';
      }
       f = Math.trunc(val*100)/100;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
    },
  },
  methods: {
    formatMoney (val) {
      var f = parseFloat(val);
      if (isNaN(f)) {
        return '0.00';
      }
      f = Math.trunc(val*100)/100;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
    },
  },
}
export default mixins



// WEBPACK FOOTER //
// ./src/mixins/moneyFormat.js